import $ from "jquery";
window.$ = window.jQuery = $;

// import validate from "jquery-validation";
// import "jquery-validation/dist/additional-methods";
import 'slick-carousel';
import 'jquery-touchswipe';

require("./bootstrap");
require("./web/main");
